module.exports = __webpack_public_path__ + "img/guzhong.ae0c79a4.jpg";